export default "/_next/static/images/b2/logo-darkmode-b20536180a37e476ef92048665c2ce7b.svg";